import { Divider, MenuList } from "@fluentui/react-components";
import { PopoverView } from "@/components/atoms/popover";
import { PresenceListItemDto } from "@/repository/models";
import { customStyle } from "./style";
import { PresenceMenuProps } from "./types";
import { PresenceMenuItem } from "../presenceMenuItem";
import { useQuery } from "@tanstack/react-query";
import {
	fetchPresencesFn,
	presencesQueryKey,
} from "@/repository/queryFns/presence";
import { useEffect, useState } from "react";

export const PresenceMenu = (props: PresenceMenuProps) => {
	const [filteredPresences, setFilteredPresences] = useState<
		PresenceListItemDto[]
	>([]);

	const { data: presences, error } = useQuery<PresenceListItemDto[]>({
		queryKey: [presencesQueryKey],
		queryFn: fetchPresencesFn,
		enabled: !props.hidePresenceOptions,
	});

	useEffect(() => {
		if (presences && presences.length > 0) {
			const localFilteredPresences = presences.map((x: PresenceListItemDto) => {
				var reasonsFilteredByQueues = x.reasons.filter((y) =>
					props.queueIds.includes(y.queueRef)
				);
				return {
					...x,
					reasons: [
						...new Map(
							reasonsFilteredByQueues.map((item) => [item.name, item])
						).values(),
					],
				};
			});
			setFilteredPresences(localFilteredPresences);
		}

		if (error) {
			console.error(error); //TODO - notification
		}
	}, [presences, error]);

	const presenceMainItemView = (presence: PresenceListItemDto) => {
		return (
			<PresenceMenuItem
				key={presence.activity}
				presenceItem={presence}
				onClick={props.onChange}
				agentState={props.agentState}
				hideReasons={props.hideReasons}
				hideLock={props.hideLock}
			/>
		);
	};

	return (
		<PopoverView
			trapFocus={true}
			positioning={props.positioning}
			trigger={props.trigger}
			content={
				<MenuList>
					{props.hidePresenceOptions ? (
						props.additionalActions
					) : (
						<>
							{filteredPresences.map(presenceMainItemView)}
							{props.additionalActions && props.additionalActions?.length > 0 && (
								<>
									<Divider />
									{props.additionalActions}
								</>
							)}
						</>
					)}
				</MenuList>
			}
			contentStyle={customStyle.statusPopover}
			open={props.open}
			onOpenChange={props.onOpenChange}
		/>
	);
};
